export function axCoerceInt(x) {
    return x | 0;
}
